export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-gray-950 text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Brand column */}
          <div className="flex-shrink-0 lg:max-w-xs">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/02174966-2660-4708-9146-ceac0d641290.png"
                alt="XEDRA d.o.o. logo"
                className="h-8 w-auto object-contain"
              />
              <span className="text-base font-semibold text-white tracking-tight whitespace-nowrap">
                XEDRA d.o.o.
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Developing modern iOS applications focused on user security and performance. Based in Vinkovci, Croatia.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row gap-10 flex-1">
            <div className="flex flex-col gap-3">
              <p className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-1">Navigation</p>
              {[
                { label: "Home", href: "#home" },
                { label: "Products", href: "#products" },
                { label: "About", href: "#about" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNav(e, link.href)}
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>

            <div className="flex flex-col gap-3">
              <p className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-1">Products</p>
              {["XEDRA VPN", "XEDRA Cleaner"].map((p) => (
                <a
                  key={p}
                  href="#products"
                  onClick={(e) => handleNav(e, "#products")}
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {p}
                </a>
              ))}
            </div>

            <div className="flex flex-col gap-3">
              <p className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-1">Contact</p>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <i className="ri-map-pin-2-line text-gray-600" />
                  <span>Antuna Aksamovica 44, Vinkovci 32100, Croatia</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <i className="ri-mail-line text-gray-600" />
                  <span>info@xedradoo.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <i className="ri-phone-line text-gray-600" />
                  <span>+1 5186327503</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500 text-center sm:text-left">
            &copy; {currentYear} XEDRA d.o.o. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">Vinkovci, Croatia</p>
        </div>
      </div>
    </footer>
  );
}
